import _ from "@/boot/lodash";
import type {
  IBillingCycle,
  IBillingTermsOption,
  IInvoiceProduct
} from "@upmind-automation/types";

export default {
  data: () => ({
    billingCyclesLoaded: false
  }),
  computed: {
    getBillingCycleName() {
      return this.$store.getters["constants/getBillingCycleName"];
    },
    billingCycles(): IBillingCycle[] {
      return this.$store.state.constants.billingCycles;
    },
    billingTermsOptions(): IBillingTermsOption[] {
      return _.map(this.billingCycles, billingTerm => ({
        value: billingTerm.months,
        label: billingTerm.name
      }));
    }
  },
  methods: {
    async created() {
      await this.getBillingCycles();
      this.billingCyclesLoaded = true;
    },

    getBillingCycles() {
      return this.$store.dispatch("constants/getBillingCycles");
    },

    /**
     * Resolves the billing term for an invoice/order line. The line-level
     * `billing_cycle_months` can be `0`/absent even for a recurring product —
     * notably on `current_data.content.products` snapshots — so fall back to
     * the term held on the related product. `0` means a one-time purchase.
     */
    getItemBillingCycleMonths(product: IInvoiceProduct) {
      return (
        product.billing_cycle_months ||
        product.product?.billing_cycle_months ||
        0
      );
    }
  }
};
